import React, { useReducer } from "react";
import { useQuery } from "@tanstack/react-query";

import { PageHeader, PageMain } from "components/molecules";
import { DeleteResourceContext, deleteResourceReducer } from "utils/store";
import { PaziaLoader } from "components/atoms";
import { TanTableClient, TanTableColumn } from "components/molecules";
import { appendFileToBrowser } from "utils";
import { QUERIES_KEYS } from "queries";
import { LogFileApi, logsApi } from "api/logsApi";
import { MdDownload } from "react-icons/md";
import { useToaster } from "utils";

export const LogsPage = () => {
  const { showError } = useToaster();
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.LOGS,
    queryFn: () => logsApi.fetch(),
  });

  const onDelete = () => {
    alert("comming soon");
  };

  const onDownload = async (fileName: string) => {
    try {
      const response = await logsApi.download(fileName);
      appendFileToBrowser(response.data, fileName);
    } catch (e) {
      console.error(e);
      showError("Nie udało się pobrać szablonu");
    }
  };

  const columns = React.useMemo<TanTableColumn<LogFileApi>[]>(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: "Nazwa pliku",
        size: 400,
      },
      {
        id: "size",
        accessorKey: "size",
        header: "Rozmiar",
        cell: (info) => `${(info.getValue<number>() / 1024).toFixed(2)} KB`,
      },
      {
        id: "actions",
        header: "Akcje",
        cell: (info) => <MdDownload onClick={() => onDownload(info.row.original.name)} />,
      },
    ],
    [],
  );

  if (isLoading) return <PaziaLoader position="center" />;
  if (!data?.data) return null;

  const methodDoesNotExist = () => {
    throw new Error("Method does not exist");
  };
  return (
    <PageMain>
      <PageHeader>Logi systemowe</PageHeader>
      <TanTableClient data={data.data} columns={columns} onDelete={onDelete} />
    </PageMain>
  );
};
